export var Implementation;
(function (Implementation) {
    Implementation["Africa GFS"] = "afr";
    Implementation["All"] = "all";
    Implementation["Australia GFS"] = "aus";
    Implementation["Australia CMC"] = "aus_cmc";
    Implementation["Australia EC"] = "aus_ec";
    Implementation["Europe GFS"] = "euro";
    Implementation["Global GFS"] = "glob";
    Implementation["Global CMC"] = "glob_cmc";
    Implementation["Global EC"] = "glob_ec";
    Implementation["Global GFS long range"] = "glob_lr";
    Implementation["Indonesia GFS"] = "indo";
    Implementation["Indian subcontinent"] = "isc";
    Implementation["Marlborough Sounds"] = "mbs";
    Implementation["Middle East"] = "me";
    Implementation["North America"] = "na";
    Implementation["New Zealand"] = "nz";
    Implementation["New Zealand CMC"] = "nz_cmc";
    Implementation["New Zealand GFS ST4"] = "nz_st4";
    Implementation["Pacific Islands"] = "pac";
    Implementation["South America"] = "sa";
    Implementation["Southern Ocean"] = "so";
})(Implementation || (Implementation = {}));
export var Gcode;
(function (Gcode) {
    Gcode[Gcode["MSL SWAN GFS (ST2)"] = 0] = "MSL SWAN GFS (ST2)";
    Gcode[Gcode["MSL SWAN GFS"] = 2] = "MSL SWAN GFS";
    Gcode[Gcode["MSL SWAN CMC"] = 3] = "MSL SWAN CMC";
    Gcode[Gcode["MSL SWAN EC"] = 4] = "MSL SWAN EC";
    Gcode[Gcode["MSL WW3 GFS"] = 7] = "MSL WW3 GFS";
    Gcode[Gcode["MSL WW3 EC"] = 8] = "MSL WW3 EC";
    Gcode[Gcode["MSL WW3 CMC"] = 9] = "MSL WW3 CMC";
    Gcode[Gcode["MSL longrange"] = 10] = "MSL longrange";
    Gcode[Gcode["MSL SCHISM GFS"] = 11] = "MSL SCHISM GFS";
    Gcode[Gcode["MSL SCHISM EC"] = 12] = "MSL SCHISM EC";
    Gcode[Gcode["obs.-based IG"] = 17] = "obs.-based IG";
    Gcode[Gcode["MS WRF EC"] = 20] = "MS WRF EC";
    Gcode[Gcode["MSL SWAN GFS TEST"] = 88] = "MSL SWAN GFS TEST";
    Gcode[Gcode["MSL SWAN EC TEST"] = 89] = "MSL SWAN EC TEST";
})(Gcode || (Gcode = {}));
export const verticalLevels = [
    0, 5, 10, 15, 20, 25, 30, 50, 75, 100, 125, 150, 200, 250, 300, 400, 500, 600, 700, 800, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 6000,
];
